<template>
  <div class="number-grow-warp">
    <span class="number-grow">{{ formattedValue }}</span>
  </div>
</template>
<script>
export default {
  name: 'NumberGrow',
  props: {
    time: {
      type: Number,
      default: 2
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentValue: 0,
      timer: null
    }
  },
  watch: {
    value() {
      this.startAnimation()
    }
  },
  computed: {
    formattedValue() {
      return this.currentValue
        .toFixed(0)
        .replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, '$1,')
    }
  },
  methods: {
    normalizeValue(value) {
      const number = Number(value)
      return Number.isFinite(number) && number > 0 ? number : 0
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    startAnimation() {
      this.clearTimer()

      const target = this.normalizeValue(this.value)
      this.currentValue = 0

      if (target === 0) {
        return
      }

      const duration = Math.max(Number(this.time) || 0, 0) * 1000
      const startTime = Date.now()

      if (duration === 0) {
        this.currentValue = target
        return
      }

      this.timer = setInterval(() => {
        const progress = Math.min((Date.now() - startTime) / duration, 1)
        this.currentValue = target * progress

        if (progress >= 1) {
          this.currentValue = target
          this.clearTimer()
        }
      }, 10)
    }
  },
  mounted() {
    this.startAnimation()
  },
  beforeUnmount() {
    this.clearTimer()
  }
}
</script>
<style>
.number-grow-warp {
  display: inline-block;
  transform: translateZ(0);
}

.number-grow {
  font-size: 36px;
  color: #888888;
  letter-spacing: 2.67px;
}
</style>
